import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaCalendarCheck, FaCalendarAlt, FaCalendarDay } from 'react-icons/fa';
import { API_BASE } from '../../config/api';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const [stats, setStats] = useState({ totalBookings: 0, upcomingBookings: 0, todayBookings: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      console.error('No admin token found');
      setLoading(false);
      return;
    }
    
    console.log('Fetching stats from:', `${API_BASE}/api/admin/stats`);
    console.log('Using token:', token.substring(0, 20) + '...');
    
    axios
      .get(`${API_BASE}/api/admin/stats`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log('Stats response:', res.data);
        const stats = res.data;
        setStats(stats);
      })
      .catch((err) => {
        console.error('Error fetching stats:', err);
        console.error('Error response:', err.response?.data);
        console.error('Error status:', err.response?.status);
        console.error('API_BASE:', API_BASE);
        // Set default values on error
        setStats({ totalBookings: 0, upcomingBookings: 0, todayBookings: 0 });
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="admin-loading">جاري التحميل...</div>;

  return (
    <div className="admin-dashboard">
      <h1 className="admin-page-title">لوحة التحكم</h1>
      <div className="admin-stats-grid">
        <div className="admin-stat-card">
          <FaCalendarCheck className="admin-stat-icon" />
          <div>
            <span className="admin-stat-value">{stats.totalBookings}</span>
            <span className="admin-stat-label">إجمالي الحجوزات</span>
          </div>
        </div>
        <div className="admin-stat-card">
          <FaCalendarAlt className="admin-stat-icon" />
          <div>
            <span className="admin-stat-value">{stats.upcomingBookings}</span>
            <span className="admin-stat-label">حجوزات قادمة</span>
          </div>
        </div>
        <div className="admin-stat-card">
          <FaCalendarDay className="admin-stat-icon" />
          <div>
            <span className="admin-stat-value">{stats.todayBookings}</span>
            <span className="admin-stat-label">حجوزات اليوم</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
